import { useSelector } from "react-redux"
import { SellCards } from "./SellCards"


export const SellDonePanel = () => {


  const { sell } = useSelector(state => state)

  return (
    <div>
        
        Ventas confirmadas y ENTREGADAS  -SellDonePanel
        
          <table>
            <thead>
              <tr>
                    <th style={{ width: 120 }} >Tramite</th>
                    <th style={{ width: 90 }} >Usuario</th>
                    {/* <th style={{ width: 250 }} >ID Usuario</th> */}
                    <th style={{ width: 130 }} >estado</th>
                    <th style={{ width: 100 }} >pago-mp</th>
                    <th style={{ width: 100 }} >steam</th>
                    <th style={{ width: 100 }} >Detalles</th>
                    <th style={{ width: 100 }} >Monto</th>
                    <th style={{ width: 100 }} >eliminar</th>
                
                    {/* <th style={{ width: 150 }} >precio</th>      
                    <th style={{ width: 150 }} ></th>      */}
              </tr>

            </thead>
              <tbody >
                { 
                sell.map(res =>

                  
                  <tr key={res.tramite} >
                    {res.estado === "entregado" && 

                    <SellCards venta={res} />
                  }
                  </tr>
                
                  
                 


                )}
              </tbody>
           </table>

        
    </div>
  )
}
